import {Box, HStack, Icon, Text} from 'platform/foundation';
import {css} from 'styled-components';

import i18n from '@dms/i18n';

export function HitlistFlag() {
  return (
    <Box backgroundColor="severity.success" borderRadius="xSmall" flexShrink={0}>
      <div
        css={css`
          padding: 1px 4px;
        `}
      >
        <HStack spacing={1} align="center">
          <Icon value="action/thumb_up" color="general.white" size={3} />
          <Text size="xxSmall" color="white" noWrap>
            {i18n.t('entity.vehicle.labels.hitlist')}
          </Text>
        </HStack>
      </div>
    </Box>
  );
}
